module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_17w.57c14e01.mp3";